import { render, staticRenderFns } from "./BirthdaysStaffBirthdays.vue?vue&type=template&id=96ce4612&scoped=true&"
import script from "./BirthdaysStaffBirthdays.vue?vue&type=script&lang=ts&"
export * from "./BirthdaysStaffBirthdays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ce4612",
  null
  
)

export default component.exports